import React from 'react';
import Matches from '../components/Matches';
import { useParams, useLocation } from 'react-router-dom';

const PlayerMatches = () => {
    const { userId } = useParams();
    const location = useLocation();
    // Get ?location=... and ?tab=... from query string
    const params = new URLSearchParams(location.search);
    const initialLocation = params.get('location') || '';
    const initialTab = params.get('tab') || 'singles';
    return <Matches userId={userId} title="Player's matches for location" cacheKeyPrefix={`player:${userId}`} initialLocation={initialLocation} initialTab={initialTab} />;
};

export default PlayerMatches;